import PropTypes from 'prop-types';
import { MediaSize } from '../../components/organisms/MediaInformation/Constants';
import { ImageTypes } from '../../types/api/ImageType';

export default PropTypes.shape({
  src: PropTypes.string,
  alt: PropTypes.string,
  copyright: PropTypes.string,
  caption: PropTypes.string,
  size: PropTypes.oneOf(Object.values(MediaSize)),
  imageType: PropTypes.oneOf(Object.values(ImageTypes)),
  orientation: PropTypes.oneOf(['portrait', 'landscape']),
  maxWidth: PropTypes.number,
  contentType: PropTypes.oneOf(['image/jpeg']),
  imageState: PropTypes.oneOf(['pending', 'ready', 'defaultImage']),
  availableWidths: PropTypes.arrayOf(PropTypes.number),
  popUp: PropTypes.bool,
});
